// Modal for setting today's per-shift production target.
// Replaces the prior browser prompt() flow with two real input fields:
//   - 件数 (the number that drives 达成率)
//   - 备注 (free text like "经典30套+特殊9套" — shown in dashboard + export)

import { useState } from 'react';
import { Modal } from './Modal.jsx';

export const DailyTargetModal = ({ shift, date, current, onSave, onClose }) => {
  const shiftLabel = shift === 'day' ? '白班' : '晚班';
  const [units, setUnits] = useState(current?.targetUnits != null ? String(current.targetUnits) : '');
  const [text, setText]   = useState(current?.targetText ?? '');
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');

  async function save() {
    const n = parseInt(units, 10);
    if (!Number.isFinite(n) || n < 0) { setErr('请输入非负整数'); return; }
    setErr('');
    setSaving(true);
    try {
      await onSave(n, text.trim() || null);
      onClose();
    } catch (e) {
      setErr(e?.message || '保存失败');
      setSaving(false);
    }
  }

  return (
    <Modal
      title={`${shiftLabel}生产目标 · ${date}`}
      onClose={onClose}
      width={420}
      footer={
        <>
          <button className="btn btn-secondary" onClick={onClose} disabled={saving}>取消</button>
          <button className="btn btn-primary" onClick={save} disabled={saving}>
            {saving ? '保存中…' : '保存'}
          </button>
        </>
      }>
      <div className="vava-field">
        <label className="vava-label">目标件数 *</label>
        <input className="vava-input"
               type="number" min="0" step="1"
               value={units}
               onChange={(e) => setUnits(e.target.value)}
               onKeyDown={(e) => e.key === 'Enter' && save()}
               placeholder="例：39"
               autoFocus />
        <div className="vava-hint">完成 / 这个数 = 今日达成率</div>
      </div>
      <div className="vava-field">
        <label className="vava-label">备注（可选）</label>
        <input className="vava-input"
               type="text"
               value={text}
               onChange={(e) => setText(e.target.value)}
               onKeyDown={(e) => e.key === 'Enter' && save()}
               placeholder="例：经典30套+特殊9套" />
        <div className="vava-hint">显示在仪表板顶部 + 导出 Excel</div>
      </div>
      {err && <div className="att-error" role="alert">{err}</div>}
    </Modal>
  );
};
